﻿export default {
    baseUrl: process.env.adminUrl,
    exportUrl: process.env.exportUrl,
    salaryUrl: process.env.salaryUrl
}